<template>
  <div class="bottom-outer" :style="{background: `url(${bgSrc}) center center / cover no-repeat`,color:color}">
    <div style="display:flex"><div class="title" >{{title}}：</div><div class="num">{{num}}</div></div>
  </div>
</template>

<script>
export default {
  props:{
    bgSrc:String,
    color:String,
    title:String,
    num:Number,
  }
}
</script>

<style lang="scss" scoped>
.bottom-outer{
  display: flex;
  width: 248px;
  height: 75px;
  flex-direction: column;
  align-items: center;
  .num{
    font-size: 24px;
    font-weight: bold;
    margin-top: 23px;
    color: #00f7ff;
  }
  .title{
    font-size: 16px;
    margin-top: 28px;
    color: white;
  }
}
</style>